import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Entity, Guard, Result, UniqueEntityID } from '@digibricks/domains';
export var PreviousQuestionId = /*#__PURE__*/function (_Entity) {
  _inherits(PreviousQuestionId, _Entity);

  var _super = _createSuper(PreviousQuestionId);

  function PreviousQuestionId() {
    _classCallCheck(this, PreviousQuestionId);

    return _super.apply(this, arguments);
  }

  _createClass(PreviousQuestionId, null, [{
    key: "create",
    value: function create(value) {
      var guardResult = Guard.againstStringNullOrEmpty(value, 'Next Question Value');

      if (!guardResult.succeeded) {
        return new BadInputError(guardResult.message);
      }

      return Result.ok(new PreviousQuestionId(null, new UniqueEntityID(value)));
    }
  }]);

  return PreviousQuestionId;
}(Entity);

_defineProperty(PreviousQuestionId, "none", PreviousQuestionId.create('none').getValue());